module.exports = __webpack_public_path__ + "static/media/answers-evaluated.e630f816.svg";